import { useMemo } from "react";
import { Outlet } from "react-router-dom";
import { TabBar } from "../TabBar";
import { Toast } from "../Toast";
import { FeedbackWidget } from "../FeedbackWidget";
import { IngestAlertBanner } from "../IngestAlertBanner";
import { NewActivitySheet } from "../../screens/NewActivitySheet";
import { ACTIVITY_CATALOG } from "../../data/activityCatalog";
import { useActivityCatalog } from "../../hooks/useActivityCatalog";
import type { ActivityEntry, ActivityIcon } from "../../state/uiStore";

export function MobileShell() {
  const { data: backendCatalog } = useActivityCatalog();

  const catalog: ActivityEntry[] = useMemo(() => {
    if (!backendCatalog?.activities?.length) return ACTIVITY_CATALOG;
    return backendCatalog.activities
      .filter((a) => a.active && !a.archived_at)
      .sort((a, b) => a.sort_order - b.sort_order)
      .map((a) => ({
        code: a.code,
        label: a.label,
        sub: a.subtitle,
        ic: (a.icon as ActivityIcon) ?? "briefcase",
        description: a.description || undefined,
        requires_worker_note: a.requires_worker_note,
      }));
  }, [backendCatalog]);

  return (
    <div className="tawa-app">
      <div className="tawa-content">
        <IngestAlertBanner />
        <Outlet />
      </div>
      <TabBar />
      <Toast />
      <NewActivitySheet catalog={catalog} />
      <FeedbackWidget showTrigger={false} />
    </div>
  );
}
